// src/components/GlobalSnackbar.js
import { Snackbar, SnackbarContent, Typography, Box } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { useSnackbar } from "../context/SnackbarContext";

const GlobalSnackbar = () => {
    const { snack, hideSnackbar } = useSnackbar();
    const { open, message, type } = snack;

    const isSuccess = type === "success";

    return (
        <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={hideSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
        <SnackbarContent
            sx={{
            bgcolor: isSuccess ? "#E8F5E9" : "#FFEBEE",
            color: isSuccess ? "#008F5D" : "#CF6679",
            border: `1px solid ${isSuccess ? "#008F5D" : "#CF6679"}`,
            px: "12px",
            justifyContent: "center",
            }}
            message={
            <Box display="flex" gap="16px" alignItems="center">
                {isSuccess ? <CheckCircleIcon /> : <ErrorIcon />}
                <Typography>{message}</Typography>
            </Box>
            }
        />
        </Snackbar>
    );
};

export default GlobalSnackbar;
